import { fetchApi } from '@/config/axiosSetting';
import { BodySingleWagesResponseType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodySingleWages/getBodySingleWagesQuery.type';

export const getBodySingleWagesQuery = ({
  id,
  wages_id,
}: {
  id: number;
  wages_id: number;
}): Promise<BodySingleWagesResponseType> =>
  fetchApi.get(`body/reports/${id}/accident_users/damaged/adjusting/wages/`, {
    params: {
      wages_id,
    },
  });
